module.exports = __webpack_public_path__ + "img/double-cross.5c8e28a5.svg";